import {
  collection,
  addDoc,
  getFirestore,
  query,
  orderBy,
  limit,
  getDocs,
  startAfter,
  endBefore,
  deleteDoc,
  doc,
  updateDoc,
  serverTimestamp,
  onSnapshot,
  Timestamp,
  where,
  setDoc,
} from "firebase/firestore";

import { LIMIT_RECORDS } from '../../Utils/constants';

export const addDocument = (collectionName, data) => {
  const db = getFirestore();
  return addDoc(collection(db, collectionName), { ...data, createdAt: serverTimestamp() });
};

export const setDocument = (collectionName, id, data) => {
  const db = getFirestore();
  return setDoc(doc(db, collectionName, id), { ...data, createdAt: serverTimestamp() });
};

export const getDocuments = async (collectionName, orderField, options) => {
  const db = getFirestore();
  let queryTmp = query(collection(db, collectionName), orderBy(orderField), limit(LIMIT_RECORDS));
  if (options?.where) {
    queryTmp = query(collection(db, collectionName),
      options.where,
    );
  }
  if (options?.lastDoc) {
    queryTmp = query(collection(db, collectionName),
      orderBy(orderField),
      startAfter(options.lastDoc),
      limit(LIMIT_RECORDS));
  }
  if (options?.firstDoc) {
    queryTmp = query(collection(db, collectionName),
      orderBy(orderField),
      endBefore(options.firstDoc),
      limit(LIMIT_RECORDS));
  }
  const querySnapshot = await getDocs(queryTmp);
  return querySnapshot.docs;
};

export const deleteDocument = (collectionName, docId) => {
  const db = getFirestore();
  return deleteDoc(doc(db, collectionName, docId));
};

export const updateDocument = (collectionName, docId, data) => {
  const db = getFirestore();
  return updateDoc(doc(db, collectionName, docId), data);
}

export const collectionChangeListener = (collectionName) => {
  const db = getFirestore();
  const q = query(collection(db, collectionName), where("createdAt", ">", Timestamp.now()));
  return onSnapshot(q, (snapshot) => {
    snapshot.docChanges().forEach((change) => {
      if (change.type === "added") {
        console.log("New city: ", change.doc.data());
      }
    });
  });
}
